import { getStore } from "../store/Store";
import { mutatorAction } from "satcheljs";
import { setItem } from "owa-local-storage";

export const setShowAllAccountsNodeMutator: (showAllAccountsNode: boolean) => void = mutatorAction("setShowAllAccountsNodeMutator", (showAllAccountsNode: boolean): void => {
    getStore().showAllAccountsNode = showAllAccountsNode;
    // Since UnifiedInbox does not belong to any specific account, we will use local storage to persist the state
    setItem(window, "IsUnifiedInboxFolderTreeHidden", (!showAllAccountsNode).toString());
});
